import type { Renderable } from '@adornis/chemistry/renderable.js';
import { html, nothing } from 'lit';

/**
 * Wraps a form field in a DaisyUI `<label>` block with the given label text.
 *
 * The form-field input components in `@adornis/forms` treat their `label`
 * prop as deprecated and don't render it themselves, so every `renderField`
 * call (and any direct input usage) needs an explicit label wrapper to
 * stay accessible and scannable. Use this helper everywhere a labeled
 * form field is rendered.
 */
export const labeledField = (label: string, field: Renderable, options?: { required?: boolean }) => html`
  <div>
    <div class="label pb-1">
      <span class="label-text">
        ${label}${options?.required ? html`<span class="text-error"> *</span>` : nothing}
      </span>
    </div>
    ${field}
  </div>
`;
